export const marketPlans = [
  {
    id: 'mp1',
    title: '时间管理黄金方案',
    author: '成都张家',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20asian%20family%20icon%20simple%20avatar%20clean%20background&width=80&height=80&seq=market-av1&orientation=squarish',
    rulesCount: 8,
    prizesCount: 6,
    usageCount: 1284,
    rating: 4.8,
    habitTags: ['timeManagement', 'studyFocus'],
    improvementRate: 87,
    avgDays: 21,
    isFree: true,
    isVip: false,
    description: '专为拖延症孩子设计，通过阶梯式奖励帮助孩子建立时间观念，3周内见效',
    price: 0,
    tags: ['热门', '推荐']
  },
  {
    id: 'mp2',
    title: '学习专注力提升计划',
    author: '北京李家',
    avatar: 'https://readdy.ai/api/search-image?query=happy%20asian%20family%20smiling%20portrait%20simple%20clean%20background&width=80&height=80&seq=market-av2&orientation=squarish',
    rulesCount: 12,
    prizesCount: 8,
    usageCount: 956,
    rating: 4.7,
    habitTags: ['studyFocus', 'responsibility'],
    improvementRate: 82,
    avgDays: 30,
    isFree: true,
    isVip: false,
    description: '结合番茄钟方法设计，适合小学3-6年级，有效提升专注学习时长',
    price: 0,
    tags: ['精选']
  },
  {
    id: 'mp3',
    title: '生活自理全能方案',
    author: '上海王家',
    avatar: 'https://readdy.ai/api/search-image?query=cheerful%20family%20portrait%20simple%20clean%20background%20cartoon%20style&width=80&height=80&seq=market-av3&orientation=squarish',
    rulesCount: 10,
    prizesCount: 7,
    usageCount: 734,
    rating: 4.6,
    habitTags: ['lifeCare', 'responsibility'],
    improvementRate: 79,
    avgDays: 28,
    isFree: true,
    isVip: false,
    description: '覆盖日常起居自理各方面，适合4-8岁孩子，逐步培养独立生活能力',
    price: 0,
    tags: ['免费']
  },
  {
    id: 'mp4',
    title: '运动健康365全年计划',
    author: '广州陈家',
    avatar: 'https://readdy.ai/api/search-image?query=sporty%20family%20healthy%20lifestyle%20portrait%20simple%20background&width=80&height=80&seq=market-av4&orientation=squarish',
    rulesCount: 15,
    prizesCount: 10,
    usageCount: 2156,
    rating: 4.9,
    habitTags: ['sportsHealth', 'responsibility'],
    improvementRate: 91,
    avgDays: 60,
    isFree: false,
    isVip: true,
    description: '体育老师联合设计，结合节气制定全年运动计划，配套丰富奖励体系',
    price: 20,
    tags: ['VIP', '爆款']
  },
  {
    id: 'mp5',
    title: '礼仪教养精品方案',
    author: '杭州赵家',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20family%20portrait%20polite%20manner%20simple%20clean%20background&width=80&height=80&seq=market-av5&orientation=squarish',
    rulesCount: 14,
    prizesCount: 9,
    usageCount: 598,
    rating: 4.7,
    habitTags: ['etiquette', 'responsibility'],
    improvementRate: 85,
    avgDays: 45,
    isFree: false,
    isVip: true,
    description: '礼仪专家顾问团队联合出品，从言行举止到待人接物全方位培养',
    price: 30,
    tags: ['VIP', '专家出品']
  },
  {
    id: 'mp6',
    title: '六维全面成长套装',
    author: '深圳刘家',
    avatar: 'https://readdy.ai/api/search-image?query=modern%20family%20portrait%20happy%20smiling%20clean%20simple%20background&width=80&height=80&seq=market-av6&orientation=squarish',
    rulesCount: 36,
    prizesCount: 24,
    usageCount: 3421,
    rating: 5.0,
    habitTags: ['timeManagement', 'studyFocus', 'lifeCare', 'sportsHealth', 'responsibility', 'etiquette'],
    improvementRate: 94,
    avgDays: 90,
    isFree: false,
    isVip: true,
    description: '终极方案！涵盖六大习惯维度，由100+家庭实测验证，适合希望全面培养孩子的家庭',
    price: 50,
    tags: ['VIP', '王牌', '热门']
  }
];
